const message = {
    moreInformation: "¿Necesitas más información?<br> <span class='text-green'> Ponte en contacto </span>con nosotros",
    send: "Enviar",
    firstName: "Nombre y apellido",
    email: "Correo electrónico",
    message: "Mensaje",
    alertSuccess: "Mensaje enviado correctamente."
};

export default message;